import jQuery from 'jquery';
import React from 'react';
import { render } from 'react-dom';
import { createHistory } from 'history';
import { Router, useRouterHistory, IndexRoute, Route } from 'react-router';
import { Provider } from 'react-redux';
import init from 'rp-gui-guide';
import popup, { backLink } from 'rp-popup';
import initNavigationPrefs from 'rp-url-navigation-prefs';

import configureStore from './configureStore';
import App from './App';
import NonRunners from './nonRunners';
import '../scss/app.scss';
import analyticsPage from './analyticsPage';

jQuery.cookie('to_force_inclusion_in_code');

const browserHistory = useRouterHistory(createHistory)({
    basename: '/non-runners/',
});

const initialState = {
    isFetching: false,
    data: window.__PRELOADED_STATE__,
};
// creating a store
/* eslint no-underscore-dangle: ["error", { "allow": ["__PRELOADED_STATE__"] }] */
const store = configureStore(initialState);
window.__PRELOADED_STATE__ = undefined;

// Create an enhanced history that syncs navigation events with the store

render(
    <Provider store={store}>
        <Router history={browserHistory}>
            <Route path="/" component={App}>
                <IndexRoute component={NonRunners} />
                <Route path="/:date" component={NonRunners} />
            </Route>
        </Router>
    </Provider>,
    document.getElementById('root'),
);

init({
    svg: { polyfill: true },
});
popup();
backLink();

initNavigationPrefs();
analyticsPage();



// WEBPACK FOOTER //
// ./src/js/index.jsx